import React from "react";
import Location from "./Location";

// A simple component that shows the pathname of the current location
class ShowLocation extends React.Component {
  render() {
    return (
      <div className={this.props.className}>
        <Location />
      </div>
    );
  }
}

export default ShowLocation;



// WEBPACK FOOTER //
// ./src/library/helper/ShowLocation.js